export default function ({ router, i18n }) {
  function skipHome(to, from, next) {
    if (to.name === 'home') {
      const locale = i18n.locale
      return next({ name: 'list', params: { locale } })
    }
    return next()
  }

  router.beforeEach(skipHome)

  return router
}
